import { render, staticRenderFns } from "./CompanyDepartment.vue?vue&type=template&id=6d1b4e7a&scoped=true&"
import script from "./CompanyDepartment.vue?vue&type=script&lang=js&"
export * from "./CompanyDepartment.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDepartment.vue?vue&type=style&index=0&id=6d1b4e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1b4e7a",
  null
  
)

export default component.exports